<template>
    <div>
        <v-card>

            <v-card-title>
                <span>{{ $t("bonusPackagePage.packageBonusesTitle", { name: package.name }) }}</span>
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        :label='$t("bonusPackagePage.search")'
                        single-line
                        hide-details
                        @keyup.enter="getData"
                ></v-text-field>
                <v-btn color="primary" @click="dialog=true">{{ $t("bonusPackagePage.new") }}</v-btn>
            </v-card-title>
            <v-data-table :headers="headers" :items="package.bonuses" :loading="loading">
                <template v-slot:items="props">
                    <td class="text-xs-start">{{ props.item.id }}</td>
                    <td class="text-xs-start">{{ props.item.min_rides }}</td>
                    <td class="text-xs-start">{{ props.item.min_bookings }}</td>
                    <td class="text-xs-start">{{ props.item.min_online_hours }}</td>
                    <td class="text-xs-start">{{ props.item.min_rating }}</td>
                    <td class="text-xs-start">{{ props.item.min_reject_rate }}</td>
                    <td class="text-xs-start">{{ props.item.min_cancellation_rate }}</td>
                    <td class="text-xs-start">{{ props.item.specific_areas }}</td>
                    <td class="text-xs-start">{{ props.item.specific_services }}</td>
                    <td class="text-xs-start">{{ props.item.prise_type }}</td>
                    <td class="text-xs-start">{{ props.item.prise_value }}</td>
                    <td class="text-xs-start">
                        <v-btn color="danger" @click="timeSlices(props.item.id)">{{ $t("bonusPackagePage.timeSlicesAction") }}</v-btn>
                    </td>
                </template>
<!--                <v-alert v-slot:no-results :value="true" color="error" icon="warning">-->
<!--                    Your search for "{{ search }}" found no results.-->
<!--                </v-alert>-->
            </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" width="40%">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("bonusPackagePage.addNewBonus") }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-form ref="form">
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field v-model="model.min_rides" :label='$t("bonusPackagePage.minRides")'></v-text-field>
                                    <v-text-field v-model="model.min_bookings" :label='$t("bonusPackagePage.minBookings")'></v-text-field>
                                    <v-text-field v-model="model.min_online_hours" :label='$t("bonusPackagePage.minOnlineHours")'></v-text-field>
                                    <v-text-field v-model="model.min_rating" :label='$t("bonusPackagePage.minRating")'></v-text-field>
                                    <v-text-field v-model="model.min_reject_rate" :label='$t("bonusPackagePage.minRejectRate")'></v-text-field>
                                    <v-text-field v-model="model.min_cancellation_rate" :label='$t("bonusPackagePage.minCancellationRate")'></v-text-field>
                                    <v-checkbox color="primary" v-model="model.specific_areas" :label='$t("bonusPackagePage.specificAreas")'></v-checkbox>
<!--                                    <choose-area-multi v-model="model.areas" v-if="model.specific_areas" label="Specific Areas"></choose-area-multi>-->
                                    <v-checkbox color="primary" v-model="model.specific_services" :label='$t("bonusPackagePage.specificServices")'></v-checkbox>
                                    <choose-service-multi v-model="model.services" v-if="model.specific_services" :label='$t("bonusPackagePage.specificServices")'></choose-service-multi>
                                    <v-select
                                            :items="['FIXED', 'PER_BOOKING', 'PER_HOUR', 'REVENUE_PERCENTAGE']"
                                            :label='$t("bonusPackagePage.priseType")'
                                            v-model="model.prise_type"
                                    >
                                    </v-select>
                                    <v-text-field
                                            v-model="model.prise_value"
                                            :label='$t("bonusPackagePage.priseValue")'
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary" @click="save" :disabled="loading">{{ $t("bonusPackagePage.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";
    import CarInfo from "@/components/confirmation_captain_components/CarInfo";
    import RidePage from "@/views/RidePage";
    import socketEventsMixin from "@/mixins/socketEventsMixin";
    import ChooseCaptainsMulti from "@/components/monaco/input/ChooseCaptainMulti";
    import ChooseDate from "@/components/monaco/input/ChooseDate";
    import ChooseServiceMulti from "@/components/monaco/input/ChooseServiceMulti";
    import ChooseAreaMulti from "@/components/monaco/input/ChooseAreaMulti";

    export default {
        mixins: [socketEventsMixin],
        name: "Package Bonuses",
        title() {
            return this.$t("bonusPackagePage.bonusesPageTitle");
        },
        components: {ChooseAreaMulti, ChooseServiceMulti, ChooseDate, ChooseCaptainsMulti, CarInfo, DataTable, RidePage},
        data() {
            return {
                package: {
                    captains: [],
                    bonuses: []
                },
                loading: false,
                search: '',
                dialog: false,
                model: {},
                id: null
            };
        },
        computed: {
            headers() {
                return [
                    {text: this.$t("bonusPackagePage.id"), value: 'id'},
                    {text: this.$t("bonusPackagePage.minRides"), value: 'min_rides'},
                    {text: this.$t("bonusPackagePage.minBookings"), value: 'min_bookings'},
                    {text: this.$t("bonusPackagePage.minOnlineHours"), value: 'min_online_hours'},
                    {text: this.$t("bonusPackagePage.minRating"), value: 'min_rating'},
                    {text: this.$t("bonusPackagePage.minRejectRate"), value: 'min_reject_rate'},
                    {text: this.$t("bonusPackagePage.minCancellationRate"), value: 'min_cancellation_rate'},
                    {text: this.$t("bonusPackagePage.specificAreas"), value: 'specific_areas'},
                    {text: this.$t("bonusPackagePage.specificServices"), value: 'specific_services'},
                    {text: this.$t("bonusPackagePage.priseType"), value: 'prise_type'},
                    {text: this.$t("bonusPackagePage.priseValue"), value: 'prise_value'},
                    {text: this.$t("bonusPackagePage.actions"), value: 'actions'},
                ];
            }
        },
        mounted() {
            this.getData();
            this.id = this.$route.params.id;
        },
        methods: {
            getData() {
                this.loading = true;
                this.axios.get(`bonus_package/${this.$route.params.id}`)
                    .then(res => this.package = res.data.data)
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            timeSlices(id) {
                this.$router.push({
                    name: "Bonus Time Slices",
                    params: {"id": id}
                })
            },
            save() {
                this.loading = true;
                this.model.bonus_package_id = this.id;
                this.axios.post(this.api.ACTIONS.BONUS, this.model)
                    .then(() => {
                        this.getData();
                        this.dialog = false;
                        window.getApp.$emit("SHOW_TOAST", this.$t("bonusPackagePage.saved"), "green");
                    })
                    .catch(err => {
                        console.log(err);
                        window.getApp.$emit("SHOW_TOAST", err.message, "red");
                    })
                    .finally(() => this.loading = false);
            },

        }
    }
</script>

<style scoped>

</style>
